<template>
    <main class="monitoring smaller-padding data-table">
        <v-data-table
            :headers="headers"
            :items="list"
            :total-items="30"
            :loading="loading"
            :hide-actions="true"
            :must-sort="true"
            :no-data-text="$t('message.generics.message.noData')"
            :no-results-text="$t('message.generics.message.noData')"
            sort-icon="mdi-chevron-down"
        >
            <v-progress-linear
                slot="progress"
                :color="providerColor"
                indeterminate
            />

            <template slot="items" slot-scope="props">
                <MonitoringTableItem
                    :warning="props.item"
                ></MonitoringTableItem>
            </template>
        </v-data-table>

        <infinite-loading :identifier="infiniteId" @infinite="load">
            <div slot="no-results"></div>
            <div slot="no-more"></div>
        </infinite-loading>
    </main>
</template>

<script>
import InfiniteLoading from "vue-infinite-loading";
import MonitoringTableItem from "./MonitoringTableItem";
import _ from "lodash";
import provider from "@mixins/provider";

export default {
    components: {
        InfiniteLoading,
        MonitoringTableItem,
    },

    data() {
        return {
            infiniteId: +new Date(),
            list: [],
            page: 0,
            loading: false,
            isFiltersLoaded: false,
        };
    },

    computed: {
        filters() {
            return this.$store.state.systemWarning.filters;
        },

        headers() {
            return [
                {
                    text: this.$t("message.monitoring.message.origin"),
                    value: "info",
                    width: "60px",
                },
                {
                    text: this.$t("message.monitoring.message.type"),
                    value: "warningType",
                },
                {
                    text: this.$t("message.monitoring.message.date"),
                    value: "creationDate",
                },
                {
                    text: this.$t("message.generics.message.status"),
                    value: "status",
                },
            ];
        },
    },

    watch: {
        filters: _.debounce(function () {
            this.isFiltersLoaded = true;
            this.list = [];
            this.page = 0;
            this.infiniteId++;
        }, 700),
    },

    mixins: [provider],

    methods: {
        async load($state) {
            //if(this.isFiltersLoaded) {
            this.loading = true;

            try {
                const formatedFilter = { ...this.filters };

                if (formatedFilter.date) {
                    formatedFilter.startDate = formatedFilter.date.min;
                    formatedFilter.endDate = formatedFilter.date.max;
                    delete formatedFilter.date;
                }

                const list = await this.$api.systemWarning.list({
                    page: this.page,
                    filters: formatedFilter,
                });

                if (list.length) {
                    this.list.push(...list);

                    this.page++;

                    $state.loaded();
                } else {
                    $state.complete();
                }
            } catch (error) {
                console.log(error);
            } finally {
                this.loading = false;
            }

            // }
        },
    },

    // async mounted() {
    //   this.load()
    //   EventBus.$on('LOAD_MONITORING', this.load)
    // },

    // beforeDestroy() {
    //     EventBus.$off('LOAD_ESTABLISHMENTS', this.load)
    // },
    mixins: [],
};
</script>

<style lang="scss" scoped>
.monitoring {
    grid-auto-rows: auto;
}

.tab-selector {
    width: 400px;
    margin: 0 auto;
}
</style>
